import React, { useEffect, useState } from 'react';
import APost from '@containers/a-post';
/**
 * Post一覧の生成
 * @param postList
 * @returns
 */
const createPostElementList = (postList) => {
    return postList.map((aPost, index) => {
        return (React.createElement(APost, { post: aPost, index: index, key: aPost.url }));
    });
};
const PostList = ({ postList }) => {
    const [postElementList, setPostElementList] = useState();
    useEffect(() => {
        if (!postList) {
            return;
        }
        setPostElementList(createPostElementList(postList));
    }, [postList]);
    useEffect(() => {
        const twitterEls = document.querySelectorAll('.c-a-post-grid-twitter');
        if (twitterEls.length === 0) {
            return;
        }
        const scriptEl = document.createElement('script');
        scriptEl.src = 'https://platform.twitter.com/widgets.js';
        document.head.appendChild(scriptEl);
    });
    return (React.createElement("div", { className: 'post-list' }, postElementList));
};
export default PostList;
